<template>
  <section class="guide-card">
    <picture>
      <source
        srcset="~images/spec_help_1x.jpg 1x, ~images/spec_help_2x.jpg 1.5x"
      />
      <img
        class="guide-card__image"
        src="~images/spec_help_2x.jpg"
        alt=""
        width="252"
        height="150"
      />
    </picture>
    <h3 class="guide-card__title">Гайд «Как искать по базе»</h3>
    <p class="guide-card__description">
      Как эффективно использовать сочетание фильтров и поисковой строки
    </p>
    <BasicButton
      href="https://career.habr.com/info/resumes_search"
      target="_blank"
      appearance="primary"
      size="l"
    >
      Узнать больше
    </BasicButton>
    <a
      class="guide-card__link"
      target="_blank"
      href="/info/resumes_search"
      @click="trackHelpClick"
    >
    </a>
  </section>
</template>

<script>
import BasicButton from 'src/components/BasicButton/BasicButton.vue';

export default {
  name: 'GuideCard',
  components: { BasicButton },
  methods: {
    trackHelpClick() {
      window.helpers.trackEventByName('banner_resumes_search_faq');
    },
  },
};
</script>
